import { render, staticRenderFns } from "./ListaMawbCoordComponent.vue?vue&type=template&id=7837b396&"
import script from "./ListaMawbCoordComponent.vue?vue&type=script&lang=js&"
export * from "./ListaMawbCoordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports